
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ZNsj", function(module, exports) {

$parcel$export(module.exports, "BannerPositioner", () => $6d2b0b868a2f629c$export$75cf49eb39e36c7);
$parcel$export(module.exports, "BannerContainer", () => $6d2b0b868a2f629c$export$f316edcbf748c37b);
/* BannerContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $3PXtn = parcelRequire("3PXtn");

var $dIouf = parcelRequire("dIouf");

var $7HO5s = parcelRequire("7HO5s");

var $cHaAi = parcelRequire("cHaAi");

var $lVsiK = parcelRequire("lVsiK");

var $hNHZN = parcelRequire("hNHZN");

var $3zufv = parcelRequire("3zufv");

var $jHaZZ = parcelRequire("jHaZZ");

var $3XLgi = parcelRequire("3XLgi");

var $9mLIQ = parcelRequire("9mLIQ");

var $luv00 = parcelRequire("luv00");

var $dtb0p = parcelRequire("dtb0p");
const $6d2b0b868a2f629c$export$75cf49eb39e36c7 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqsw1n9t _1bsb1osq _154iidpf _1ltvidpf _1pby1fss",
            __cmplp.className
        ])
    });
});
const $6d2b0b868a2f629c$var$BannerContainerComponent = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($6d2b0b868a2f629c$export$75cf49eb39e36c7, {
        "data-vc": "banner-container-component",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dtb0p.Nav4PromptBannerLoadable), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hNHZN.GracePeriodBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7HO5s.SuperAdminBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $cHaAi.PageWasInactiveBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3zufv.StorageEnforcementBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lVsiK.AdminAnnouncementBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jHaZZ.CookiesConsentBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3XLgi.UnsupportedBrowserBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9mLIQ.DevToolsBanner), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3PXtn.BannerSpacer), props));
};
const $6d2b0b868a2f629c$export$f316edcbf748c37b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo($6d2b0b868a2f629c$var$BannerContainerComponent);

});
parcelRegister("cHaAi", function(module, exports) {

$parcel$export(module.exports, "PageWasInactiveBanner", () => $880f9466dc5f2c8e$export$6d11cadf32c4517a);
/* PageWasInactiveBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $ipPpS = parcelRequire("ipPpS");

var $2KpT3 = parcelRequire("2KpT3");
var $3XjWl = parcelRequire("3XjWl");
var $irVI7 = parcelRequire("irVI7");

var $dIouf = parcelRequire("dIouf");

var $3PXtn = parcelRequire("3PXtn");

var $18HQ4 = parcelRequire("18HQ4");
const $880f9466dc5f2c8e$var$i18n = (0, $2nPZH.defineMessages)({
    pageWasBackgrounded: {
        id: "browser-status-indicator.page.was.backgrounded",
        defaultMessage: "Your content may not have fully loaded. Try to {refreshLink}"
    },
    refreshLink: {
        id: "browser-status-indicator.refresh.the.page",
        defaultMessage: "refresh now"
    }
});
const $880f9466dc5f2c8e$var$BANNER_NAME = 'PageWasInactiveBanner';
const $880f9466dc5f2c8e$var$BANNER_HEIGHT = 32; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $880f9466dc5f2c8e$var$PageWasInactiveBannerContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _4t3izwfg _1e0c1txw _bfhk11bn _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $880f9466dc5f2c8e$var$RefreshLink = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $18HQ4.StyledRefreshLink), {
        target: "_blank",
        onClick: ()=>window.location.reload()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $880f9466dc5f2c8e$var$i18n.refreshLink, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, text))); // Experiences to track
const $880f9466dc5f2c8e$var$EXPERIENCES = [
    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
]; // Delay before making this banner become visible
// when viewing a tab that was previously hidden.
const $880f9466dc5f2c8e$var$ON_VIEW_TAB_DELAY = 1000;
const $880f9466dc5f2c8e$export$91f065510e8e6998 = /*#__PURE__*/ (0, $gwFzn.memo)(({ bannerState: bannerState })=>{
    const [documentVisible, setDocumentVisible] = (0, $gwFzn.useState)(false);
    const experienceStates = $880f9466dc5f2c8e$var$EXPERIENCES.map((0, $3XjWl.useExperienceState));
    (0, $gwFzn.useEffect)(()=>{
        const changeVisibility = ()=>{
            // When a tab's visibility changes, wait a small amount before updating documentVisible.
            // This prevents a flicker of this banner that sometimes occurs
            // when a tab that is loading in the background becomes visible.
            setTimeout(()=>{
                setDocumentVisible(!document.hidden);
            }, $880f9466dc5f2c8e$var$ON_VIEW_TAB_DELAY);
        };
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>document.removeEventListener('visibilitychange', changeVisibility);
    });
    const showBanner = documentVisible && experienceStates.some((experienceState)=>{
        // dont show the banner if:
        // !experienceState - if an experience has not started
        // !experienceState.timeout - if the experience does not rely on timeout
        if (!experienceState || !experienceState.timeout) return false;
        const { startTime: startTime = 0, timeout: timeout, hasStopped: hasStopped } = experienceState;
        const absoluteDuration = Math.round(window.performance.now() - startTime);
        const adjustedTabActiveTime = absoluteDuration - (0, $2KpT3.getTabInactivityTracker)().getInactiveMillisecondsSince(startTime);
        const insufficientActiveTime = adjustedTabActiveTime < timeout;
        return !hasStopped && insufficientActiveTime;
    });
    if (showBanner) {
        bannerState.show($880f9466dc5f2c8e$var$BANNER_NAME, $880f9466dc5f2c8e$var$BANNER_HEIGHT);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($880f9466dc5f2c8e$var$PageWasInactiveBannerContainer, {
            "data-testid": "inactive-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $18HQ4.FadingSpan), {
            show: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $18HQ4.StyledText), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$880f9466dc5f2c8e$var$i18n.pageWasBackgrounded,
            values: {
                refreshLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($880f9466dc5f2c8e$var$RefreshLink, null)
            }
        }))));
    } else {
        bannerState.hide($880f9466dc5f2c8e$var$BANNER_NAME);
        return null;
    }
});
const $880f9466dc5f2c8e$export$6d11cadf32c4517a = (0, $dIouf.withTransparentErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PAGE_MODES
})(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($880f9466dc5f2c8e$export$91f065510e8e6998, {
            bannerState: bannerState
        });
    });
});

});
parcelRegister("3XjWl", function(module, exports) {

$parcel$export(module.exports, "useExperienceState", () => $a5d6810b007644fc$export$4a4fb33de7d01f75);

var $gwFzn = parcelRequire("gwFzn");

var $1kHsc = parcelRequire("1kHsc");
const $a5d6810b007644fc$export$4a4fb33de7d01f75 = (experienceName)=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [experienceState, setExperienceState] = (0, $gwFzn.useState)(experienceTracker.getExperienceState(experienceName));
    (0, $gwFzn.useEffect)(()=>experienceTracker.subscribe((e)=>{
            if (e.name === experienceName) setExperienceState(experienceTracker.getExperienceState(experienceName));
        }), [
        experienceName,
        experienceTracker
    ]);
    return experienceState;
};

});

parcelRegister("18HQ4", function(module, exports) {

$parcel$export(module.exports, "StatusIndicator", () => $4dfb2d8a6603cd21$export$b4f88f0ca5784eef);
$parcel$export(module.exports, "StyledText", () => $4dfb2d8a6603cd21$export$31ea92f3997410dd);
$parcel$export(module.exports, "FadingSpan", () => $4dfb2d8a6603cd21$export$bb5d4b172e6970cd);
$parcel$export(module.exports, "EllipsisContainer", () => $4dfb2d8a6603cd21$export$91672a4b819b5126);
$parcel$export(module.exports, "AnimatedDot", () => $4dfb2d8a6603cd21$export$c30cc6d619162254);
$parcel$export(module.exports, "StyledRefreshLink", () => $4dfb2d8a6603cd21$export$b9ead157d7292e86);
/* BrowserIndicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $aFUXX = parcelRequire("aFUXX");
const $4dfb2d8a6603cd21$export$adb584737d712b70 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1lnnvun": (0, $iAWao.default)((0, $aFUXX.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)())
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_v56417u1 _1e0c1txw _kqswstnw _1bsb1osq _1pbykb7n _1bah1h6o _4cvr1h6o _1ltvze3t _4t3ixy5q _bfhk11bn _8hrzjp4b",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154irowa",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_1911rowa",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b4f88f0ca5784eef = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = $4dfb2d8a6603cd21$export$adb584737d712b70, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1pby1fw0",
            __cmplp.show && __cmplp.showOnlineBackground ? "_bfhkmv6i" : "_bfhk11bn",
            __cmplp.className
        ])
    });
}); // TODO: Figure out why @compiled is having trouble with the @media lambda function below.
const $4dfb2d8a6603cd21$export$31ea92f3997410dd = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { mediaMaxWidth: mediaMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1enk3bj": (0, $iAWao.default)(__cmplp.mediaMaxWidth)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _ect41kw7 _k48pmoej _1wyb1crf _syaz131l _18u0u2gc _o5721q9c _1hma11y2",
            __cmplp.className
        ])
    });
});
$4dfb2d8a6603cd21$export$31ea92f3997410dd.defaultProps = {
    mediaMaxWidth: '650px'
};
const $4dfb2d8a6603cd21$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4dfb2d8a6603cd21$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dfb2d8a6603cd21$var$FadingSpanInternal = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_v564ayzn _1e0c1txw _4cvr1h6o _kqswstnw",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$91672a4b819b5126 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvresu3 _4t3iu2gc _18u0v77o",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$c30cc6d619162254 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1ssb _11q7131l _y44v1dpe _1e0c1o8l _1bsbv77o _4t3iv77o _2hwxv77o _1dvn10n5 _8rwrg43g",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b9ead157d7292e86 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c81o8v _k48pmoej _syaz1e6v",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lVsiK", function(module, exports) {

$parcel$export(module.exports, "AdminAnnouncementBanner", () => $d686d040b673d1ca$export$f449ad63dc7e8a0f);

var $jmjWc = parcelRequire("jmjWc");

const $d686d040b673d1ca$export$f449ad63dc7e8a0f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lkLmI",
    name: "AdminAnnouncementBanner",
    loader: async ()=>(await (parcelRequire("lVy7N"))).AdminAnnouncementBanner
});

});
parcelRegister("lVy7N", function(module, exports) {

let $ff696452be67dbd2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ff696452be67dbd2$var$load("eIzhm"),
    $ff696452be67dbd2$var$load("c6MKV"),
    $ff696452be67dbd2$var$load("aZinD"),
    $ff696452be67dbd2$var$load("6qah4"),
    $ff696452be67dbd2$var$load("bMgpg"),
    $ff696452be67dbd2$var$load("iBa9k"),
    $ff696452be67dbd2$var$load("fbsPn")
]).then(()=>parcelRequire('64Kn9'));

});


parcelRegister("hNHZN", function(module, exports) {

$parcel$export(module.exports, "GracePeriodBanner", () => $fde0386be42ce743$export$25e97e90a802d73);

var $jmjWc = parcelRequire("jmjWc");

const $fde0386be42ce743$export$25e97e90a802d73 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "k7WTy",
    name: "GracePeriodBanner",
    loader: async ()=>(await (parcelRequire("ljV0u"))).GracePeriodBanner
});

});
parcelRegister("ljV0u", function(module, exports) {

let $f85797b809fd8881$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f85797b809fd8881$var$load("cmcKh"),
    $f85797b809fd8881$var$load("7Q0UC"),
    $f85797b809fd8881$var$load("cjDIz")
]).then(()=>parcelRequire('1gsg0'));

});


parcelRegister("3zufv", function(module, exports) {

$parcel$export(module.exports, "StorageEnforcementBanner", () => $a393ba0851d433ea$export$8140039602269ff0);

var $gwFzn = parcelRequire("gwFzn");

var $jmjWc = parcelRequire("jmjWc");

var $alLTz = parcelRequire("alLTz");

const $a393ba0851d433ea$var$StorageEnforcementBannerLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VZcGs",
    name: "StorageEnforcementBannerLoadable",
    loader: async ()=>(await (parcelRequire("2F4YX"))).StorageEnforcementBanner
});
const $a393ba0851d433ea$export$8140039602269ff0 = ()=>{
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    return isEligibleUser ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a393ba0851d433ea$var$StorageEnforcementBannerLoadable, null) : null;
};

});
parcelRegister("alLTz", function(module, exports) {

$parcel$export(module.exports, "useIsStorageEnforcementEligible", () => $2f3a7af74886cca0$export$3fc4fcb674af9bce);

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");
const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};

});

parcelRegister("2F4YX", function(module, exports) {

let $1f034673c452400d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1f034673c452400d$var$load("7Q0UC"),
    $1f034673c452400d$var$load("4uVag")
]).then(()=>parcelRequire('3Atou'));

});


parcelRegister("jHaZZ", function(module, exports) {

$parcel$export(module.exports, "CookiesConsentBanner", () => $62400dd446426ff7$export$494acd77efce1d72);
/* CookiesConsentBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $ipPpS = parcelRequire("ipPpS");

var $2jjxD = parcelRequire("2jjxD");

var $4JDbp = parcelRequire("4JDbp");

var $jmjWc = parcelRequire("jmjWc");

var $3PXtn = parcelRequire("3PXtn");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $izuD1 = parcelRequire("izuD1");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62400dd446426ff7$var$Banner = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $62400dd446426ff7$var$BannerContent = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

const $62400dd446426ff7$var$ConsentBannerComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BMpKa",
    name: "ConsentBannerComponent",
    loader: async ()=>(await (parcelRequire("7Ks9G"))).ConsentBannerWrapper
});
const $62400dd446426ff7$var$CookiesConsentBannerComponent = ({ bannerState: bannerState })=>{
    const bannerRef = (0, $gwFzn.useRef)(null);
    const { onWidthChange: onWidthChange, showBanner: showBanner, hideBanner: hideBanner, prefetchedData: prefetchedData } = (0, $izuD1.useCookiesConsentBanner)(bannerState, bannerRef);
    const onResize = (0, (/*@__PURE__*/$parcel$interopDefault($2jjxD)))(onWidthChange, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($62400dd446426ff7$var$Banner, {
        ref: bannerRef,
        role: "banner",
        "data-testid": "cookie-consent-banner",
        "data-vc": "cookie-consent-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($62400dd446426ff7$var$BannerContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4JDbp.WidthObserver), {
        setWidth: onResize
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($62400dd446426ff7$var$ConsentBannerComponent, {
        product: "Confluence",
        onShow: showBanner,
        onHide: hideBanner,
        initialPreferences: prefetchedData,
        isSSRPrefetchImplemented: (0, $9wGTI.fg)('confluence_frontend_fix_inconsistent_cookie_banner')
    })));
};
const $62400dd446426ff7$export$494acd77efce1d72 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($62400dd446426ff7$var$CookiesConsentBannerComponent, {
            bannerState: bannerState
        });
    }));
};

});
parcelRegister("4JDbp", function(module, exports) {

$parcel$export(module.exports, "WidthObserver", () => $b400565b9de87bc3$export$b2ad68b9bc407b80);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $i7RGj = parcelRequire("i7RGj");
const $b400565b9de87bc3$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo((props)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $i7RGj.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $b400565b9de87bc3$export$2e2bcd8739ae039 = $b400565b9de87bc3$export$b2ad68b9bc407b80;

});
parcelRegister("i7RGj", function(module, exports) {

$parcel$export(module.exports, "WidthDetectorObserver", () => $0e043a05e9b77ebf$export$ff983d2a2b6112ea);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $lfOVK = parcelRequire("lfOVK");
const $0e043a05e9b77ebf$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $lfOVK.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("lfOVK", function(module, exports) {

$parcel$export(module.exports, "useInView", () => $72cd6c8cfec5859a$export$2f62ee6831462844);

var $gwFzn = parcelRequire("gwFzn");
function $72cd6c8cfec5859a$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



parcelRegister("izuD1", function(module, exports) {

$parcel$export(module.exports, "useCookiesConsentBanner", () => $c7b80e7d1fbd63c2$export$6a299f8d1d8b3beb);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");



var $dNKzi = parcelRequire("dNKzi");
function $c7b80e7d1fbd63c2$export$6a299f8d1d8b3beb(bannerState, bannerRef) {
    const cookiesDialogRef = (0, $gwFzn.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [height, setHeight] = (0, $gwFzn.useState)((0, $dNKzi.MIN_BANNER_HEIGHT));
    const prefetchedData = Object.keys(window?.__COOKIE_CONSENT_PREFERENCES__ || {}).length ? window.__COOKIE_CONSENT_PREFERENCES__ : undefined;
    let shouldRenderInitial = null;
    const [shouldRender, setShouldRender] = (0, $gwFzn.useState)(shouldRenderInitial);
    if (shouldRender) bannerState?.show((0, $dNKzi.BANNER_NAME), height);
    else if (shouldRender === false) bannerState?.hide((0, $dNKzi.BANNER_NAME));
    const findCookiesDialog = (0, $gwFzn.useCallback)(()=>{
        if (cookiesDialogRef?.current) return cookiesDialogRef?.current;
        if (!bannerRef?.current) return null;
        const childDivs = bannerRef?.current.getElementsByTagName('div');
        let cookiesDialog = null;
        for (const element of Object.values(childDivs)){
            if (!element.offsetHeight) continue;
            // @ts-ignore - Type 'HTMLDivElement' is not assignable to type 'null'
            // Using `ts-ignore` and not `ts-expect-error` here as TypeScript will fail on this line without `ts-ignore` but with `ts-expect-error`
            // This error was introduced after upgrading to TypeScript 5
            cookiesDialog = element;
            break;
        }
        cookiesDialogRef.current = cookiesDialog;
        return cookiesDialog;
    }, [
        bannerRef
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldRender) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            action: 'rendered',
            actionSubject: 'cookiesConsentBanner'
        }).fire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldRender
    ]);
    const onWidthChange = (0, $gwFzn.useCallback)(()=>{
        const cookiesDialog = findCookiesDialog();
        if (!cookiesDialog) return;
        setHeight(cookiesDialog.offsetHeight);
    }, [
        findCookiesDialog
    ]);
    const showBanner = (0, $gwFzn.useCallback)(()=>{
        setShouldRender(true);
        onWidthChange();
    }, [
        onWidthChange
    ]);
    const hideBanner = (0, $gwFzn.useCallback)(()=>{
        setShouldRender(false);
    }, []);
    return {
        shouldRender: shouldRender,
        showBanner: showBanner,
        hideBanner: hideBanner,
        onWidthChange: onWidthChange,
        prefetchedData: prefetchedData
    };
}

});
parcelRegister("dNKzi", function(module, exports) {

$parcel$export(module.exports, "MIN_BANNER_HEIGHT", () => $403d7842519953c9$export$afc8b28843b075c1);
$parcel$export(module.exports, "BANNER_NAME", () => $403d7842519953c9$export$41956b146268af93);

var $1To4a = parcelRequire("1To4a");

var $ajUkR = parcelRequire("ajUkR");
const $403d7842519953c9$var$PADDING_FALLBACK = '16px';
const $403d7842519953c9$var$BORDER_FALLBACK = '1px';
// Padding and border values mirror Platform ConsentBanner which defaults to 74px height https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/browse/platform/packages/policy-platform/browser-storage-controls/src/ui/consent-banner/presentational-consent-banner/index.tsx?until=0ae69184856fc16979bf360b0d23f0adbe832d0d&untilPath=platform%2Fpackages%2Fpolicy-platform%2Fbrowser-storage-controls%2Fsrc%2Fui%2Fconsent-banner%2Fpresentational-consent-banner%2Findex.tsx#16
const $403d7842519953c9$var$padding = (0, $ajUkR.convertRemToPixel)((0, $1To4a.default)('space.200', $403d7842519953c9$var$PADDING_FALLBACK));
const $403d7842519953c9$var$borderWidth = (0, $ajUkR.convertRemToPixel)((0, $1To4a.default)('border.width', $403d7842519953c9$var$BORDER_FALLBACK));
const $403d7842519953c9$export$afc8b28843b075c1 = 40 + $403d7842519953c9$var$padding * 2 + $403d7842519953c9$var$borderWidth * 2;
const $403d7842519953c9$export$41956b146268af93 = 'CookiesConsentBanner';

});
parcelRegister("ajUkR", function(module, exports) {

$parcel$export(module.exports, "convertRemToPixel", () => $467c3225fb18edbe$export$61dd5892133e0813);
const $467c3225fb18edbe$export$62d5108487a08409 = ()=>{
    const fallback = 16; // 16px is the default rem size for most browsers
    if (typeof document === 'undefined' || typeof getComputedStyle === 'undefined') return fallback;
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || fallback;
};
const $467c3225fb18edbe$export$61dd5892133e0813 = (tokenValue)=>{
    if (!tokenValue.includes('rem')) return parseInt(tokenValue);
    return parseInt(tokenValue) * $467c3225fb18edbe$export$62d5108487a08409();
};

});



parcelRegister("7Ks9G", function(module, exports) {

let $5a42ab4eb4fc5d92$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $5a42ab4eb4fc5d92$var$load("7ZMdq"),
    $5a42ab4eb4fc5d92$var$load("12s7O"),
    $5a42ab4eb4fc5d92$var$load("hKaYu"),
    $5a42ab4eb4fc5d92$var$load("c6MKV"),
    $5a42ab4eb4fc5d92$var$load("aZinD"),
    $5a42ab4eb4fc5d92$var$load("4Pn6Z"),
    $5a42ab4eb4fc5d92$var$load("hmjlF")
]).then(()=>parcelRequire('hs7Sl'));

});


parcelRegister("3XLgi", function(module, exports) {

$parcel$export(module.exports, "UnsupportedBrowserBanner", () => $a0d38a398101db6d$export$77b99dfa740609c2);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $7eXBl = parcelRequire("7eXBl");

var $2Nwuj = parcelRequire("2Nwuj");

var $9wGTI = parcelRequire("9wGTI");

var $3PXtn = parcelRequire("3PXtn");

var $dIouf = parcelRequire("dIouf");

var $eSDUO = parcelRequire("eSDUO");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $04e9M = parcelRequire("04e9M");

var $cMvQV = parcelRequire("cMvQV");

var $evQnO = parcelRequire("evQnO");
const $a0d38a398101db6d$var$BANNER_HEIGHT = 72; // 72px when gridSize = 8px
const $a0d38a398101db6d$var$BANNER_NAME = 'UnsupportedBrowserBanner';
const $a0d38a398101db6d$var$messages = (0, $2nPZH.defineMessages)({
    bannerMessage: {
        id: "unsupported-browser-banner.banner-message",
        defaultMessage: "Your browser is <link>unsupported</link>. Switch or upgrade to maintain optimal performance."
    },
    bannerLink: {
        id: "unsupported-browser-banner.banner-link",
        defaultMessage: "unsupported"
    }
});
const $a0d38a398101db6d$var$BannerLink = (str)=>(0, $9wGTI.fg)('dst-a11y__replace-anchor-with-link__fe-platform-an') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Nwuj.default), {
        href: "https://support.atlassian.com/atlassian-account/docs/supported-browsers-for-atlassian-cloud-products/",
        target: "_blank",
        rel: "noreferrer noopener"
    }, str) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
        href: "https://support.atlassian.com/atlassian-account/docs/supported-browsers-for-atlassian-cloud-products/",
        target: "_blank",
        rel: "noreferrer noopener"
    }, str);
const $a0d38a398101db6d$var$UnsupportedBrowserBannerComponent = ({ bannerState: bannerState, setIsBannerClosed: setIsBannerClosed, isBannerClosed: isBannerClosed })=>{
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        const bannerClosedByUser = (0, $e9zUf.confluenceSessionStorageInstance).getItemAsBoolean((0, $1UApO.keys).BROWSER_BANNER_CLOSED_BY_USER);
        if (bannerClosedByUser) {
            setIsBannerClosed(true);
            bannerState.hide($a0d38a398101db6d$var$BANNER_NAME);
        }
    }, [
        setIsBannerClosed,
        isBannerClosed,
        bannerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eSDUO.DismissibleBanner), {
        height: $a0d38a398101db6d$var$BANNER_HEIGHT,
        isWarning: true,
        onDismiss: ()=>{
            bannerState.hide($a0d38a398101db6d$var$BANNER_NAME);
            setIsBannerClosed(true);
            (0, $e9zUf.confluenceSessionStorageInstance).setItem((0, $1UApO.keys).BROWSER_BANNER_CLOSED_BY_USER, true);
        }
    }, intl.formatMessage($a0d38a398101db6d$var$messages.bannerMessage, {
        link: $a0d38a398101db6d$var$BannerLink
    }));
};
const $a0d38a398101db6d$export$77b99dfa740609c2 = ()=>{
    const [isBannerClosed, setIsBannerClosed] = (0, $gwFzn.useState)(true);
    const failedFullCapabilitiesBrowserCheck = (0, $evQnO.showBrowserRuntimeWarning)();
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $gwFzn.useEffect)((0, $cMvQV.setUserAgent), []);
    // Display banner if full browser capabilities check failed
    (0, $gwFzn.useEffect)(()=>{
        if (failedFullCapabilitiesBrowserCheck) setIsBannerClosed(false);
    }, [
        failedFullCapabilitiesBrowserCheck,
        setIsBannerClosed
    ]);
    const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($7eXBl)))(navigator.userAgent);
    const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
    // collect analytics
    (0, $gwFzn.useEffect)(()=>{
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendOperationalEvent({
                source: 'unsupportedBrowserBanner',
                action: 'executed',
                actionSubject: 'browserRuntimeCheck',
                attributes: {
                    failedFullBrowserCheck: failedFullCapabilitiesBrowserCheck,
                    browserName: browserName,
                    browserVersion: browserVersion
                }
            });
        });
    }, [
        failedFullCapabilitiesBrowserCheck,
        browserName,
        browserVersion
    ]);
    if (isBannerClosed || !failedFullCapabilitiesBrowserCheck || (0, $cMvQV.isNativeMobile)() // Do not render the banner in the Confluence native mobile app
    ) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>{
        bannerState.show($a0d38a398101db6d$var$BANNER_NAME, $a0d38a398101db6d$var$BANNER_HEIGHT);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a0d38a398101db6d$var$UnsupportedBrowserBannerComponent, {
            bannerState: bannerState,
            setIsBannerClosed: setIsBannerClosed,
            isBannerClosed: isBannerClosed
        });
    }));
};

});
parcelRegister("eSDUO", function(module, exports) {

$parcel$export(module.exports, "DismissibleBanner", () => $77f2946a7e231fe8$export$f43e5701f59b92d6);
/* DismissibleBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $jP4Hx = parcelRequire("jP4Hx");

var $2p7B1 = parcelRequire("2p7B1");

var $lnqHu = parcelRequire("lnqHu");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$BannerContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWarning: isWarning, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $iAWao.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt4ze3t _1bsb1osq _vchhusvi _4t3i2nrh _y3gn1h6o _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isWarning ? "_bfhk190i" : "_bfhk1t1b",
            __cmplp.className
        ])
    });
});
const $77f2946a7e231fe8$var$MAX_BANNER_HEIGHT = 28; // 28px when gridSize = 8px
const $77f2946a7e231fe8$var$BANNER_FONT_SIZE = $77f2946a7e231fe8$var$MAX_BANNER_HEIGHT / 2; // 14px when gridSize = 8px
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$Banner = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWarning: isWarning, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _c71l1f4h _1wybdlk8 _k48p1wq8",
            __cmplp.isWarning ? "_bfhk190i" : "_bfhk1t1b",
            __cmplp.isWarning ? "_syazal3n" : "_syaz15cr",
            __cmplp.className
        ])
    });
});
const $77f2946a7e231fe8$var$BannerContent = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s81s16 _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $77f2946a7e231fe8$var$BannerText = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1yt41b66",
            __cmplp.className
        ])
    });
});
const $77f2946a7e231fe8$var$BANNER_DISMISS_BUTTON_SIZE = 24;
// 24px when gridSize = 8px
const $77f2946a7e231fe8$var$BANNER_DISMISS_BUTTON_RIGHT_OFFSET = 10;
// 10px when gridSize = 8px
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $77f2946a7e231fe8$var$BannerDismissButton = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isWarning: isWarning, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_4t3i1tcg _1bsb1tcg _80omtlke _kqswstnw _1xi219bv",
            __cmplp.isWarning ? "_bfhk190i" : "_bfhk1t1b",
            __cmplp.isWarning ? "_syazal3n" : "_syaz15cr",
            __cmplp.isWarning ? "_30l3al3n" : "_30l315cr",
            __cmplp.className
        ])
    });
});
const $77f2946a7e231fe8$var$BannerMessages = (0, $2nPZH.defineMessages)({
    closeLabel: {
        id: "banners.dismissible-banner.close-label",
        defaultMessage: "Close"
    }
});
const $77f2946a7e231fe8$export$f43e5701f59b92d6 = ({ height: height, children: children, onView: onView = (0, (/*@__PURE__*/$parcel$interopDefault($jP4Hx))), onDismiss: onDismiss = (0, (/*@__PURE__*/$parcel$interopDefault($jP4Hx))), isWarning: isWarning = false })=>{
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        onView();
    }, [
        onView
    ]); // This constant is copied from the <AKBanner> source code as our custom <Banner> is replacing an
    // <AkBanner>.  This code has 2 purposes: to add the accessibility attributes of the <AkBanner>
    // so screen readers work the same with the custom banner, and to keep the unit tests functioning
    // as the tests are looking for the aria-label.
    const accessibilityProps = (0, $gwFzn.useMemo)(()=>{
        const baseProps = {
            role: 'alert'
        };
        if (!isWarning) return {
            ...baseProps,
            'aria-label': 'announcement',
            tabIndex: 0,
            role: 'region'
        };
        return baseProps;
    }, [
        isWarning
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($77f2946a7e231fe8$var$BannerContainer, {
        "data-testid": "banner-container",
        height: height,
        isWarning: isWarning
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($77f2946a7e231fe8$var$BannerContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($77f2946a7e231fe8$var$Banner, {
        isWarning: isWarning,
        ...accessibilityProps
    }, isWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2p7B1))), {
        spacing: "spacious",
        label: "Warning icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($77f2946a7e231fe8$var$BannerText, null, children))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($77f2946a7e231fe8$var$BannerDismissButton, {
        "data-testid": "banner-dismiss-button",
        onClick: onDismiss,
        isWarning: isWarning,
        role: "button",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
        spacing: "spacious",
        label: intl.formatMessage($77f2946a7e231fe8$var$BannerMessages.closeLabel)
    })));
};

});

parcelRegister("evQnO", function(module, exports) {

$parcel$export(module.exports, "showBrowserRuntimeWarning", () => $e2d8ee7ae3e69da0$export$ac0a59655c5ab60c);

var $fUU6t = parcelRequire("fUU6t");
const $e2d8ee7ae3e69da0$export$ac0a59655c5ab60c = ()=>!(0, $fUU6t.fullCapabilitiesSupportedBrowsers).test(navigator.userAgent);

});
parcelRegister("fUU6t", function(module, exports) {

$parcel$export(module.exports, "fullCapabilitiesSupportedBrowsers", () => $09adc8c702586d16$export$88284c4a582e5a0c);
// This file was automatically generated and should not be edited.
const $09adc8c702586d16$export$88284c4a582e5a0c = /Edge?\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|Firefox\/(7[89]|[89]\d|\d{3,})\.\d+(\.\d+|)|Chrom(ium|e)\/(8[5-9]|9\d|\d{3,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(16\.([4-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|Chrome.+OPR\/(8[5-9]|9\d|\d{3,})\.\d+\.\d+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(16[._]([4-9]|\d{2,})|(1[7-9]|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android:?[ /-](129|1[3-9]\d|[2-9]\d{2}|\d{4,})(\.\d+|)(\.\d+|)|Mobile Safari.+OPR\/([89]\d|\d{3,})\.\d+\.\d+|Android.+Firefox\/(13\d|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+Chrom(ium|e)\/(129|1[3-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Android.+(UC? ?Browser|UCWEB|U3)[ /]?(15\.([5-9]|\d{2,})|(1[6-9]|[2-9]\d|\d{3,})\.\d+)\.\d+|SamsungBrowser\/(2[4-9]|[3-9]\d|\d{3,})\.\d+|Android.+MQ{2}Browser\/(14(\.(9|\d{2,})|)|(1[5-9]|[2-9]\d|\d{3,})(\.\d+|))(\.\d+|)|K[Aa][Ii]OS\/(3\.\d+|([4-9]|\d{2,})\.\d+)(\.\d+|)/;

});



parcelRegister("9mLIQ", function(module, exports) {

$parcel$export(module.exports, "DevToolsDialog", () => $6d1b2fcade0e4c0b$export$23eed8de2215911d);
$parcel$export(module.exports, "DevToolsBanner", () => $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82);

var $jmjWc = parcelRequire("jmjWc");

const $6d1b2fcade0e4c0b$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "J4uP_",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("adxhf"))).DevToolsDialog
});

const $6d1b2fcade0e4c0b$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rSlGt",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("4U9I9"))).DevToolsBanner
});

});
parcelRegister("adxhf", function(module, exports) {

let $01eb6f334e5b0f36$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $01eb6f334e5b0f36$var$load("cOBj9"),
    $01eb6f334e5b0f36$var$load("jgfeV"),
    $01eb6f334e5b0f36$var$load("1Jok2"),
    $01eb6f334e5b0f36$var$load("7KgfJ"),
    $01eb6f334e5b0f36$var$load("gYKCE"),
    $01eb6f334e5b0f36$var$load("2uoBF"),
    $01eb6f334e5b0f36$var$load("c6MKV"),
    $01eb6f334e5b0f36$var$load("aZinD"),
    $01eb6f334e5b0f36$var$load("4Pn6Z"),
    $01eb6f334e5b0f36$var$load("i4Poh")
]).then(()=>parcelRequire('FAgdQ'));

});

parcelRegister("4U9I9", function(module, exports) {

let $3923ecd66adb56d4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3923ecd66adb56d4$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});


parcelRegister("dtb0p", function(module, exports) {

$parcel$export(module.exports, "Nav4PromptBanner", () => $f35d5c2a7033b5e6$export$18e39ddabf189c4);
$parcel$export(module.exports, "Nav4PromptBannerLoadable", () => $f35d5c2a7033b5e6$export$268b68c89890fd2b);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $jmjWc = parcelRequire("jmjWc");

var $dIouf = parcelRequire("dIouf");

var $3PXtn = parcelRequire("3PXtn");

var $9wGTI = parcelRequire("9wGTI");

var $ebWzV = parcelRequire("ebWzV");

var $86NSs = parcelRequire("86NSs");
const $f35d5c2a7033b5e6$var$Nav4PromptBannerContainerComponent = ({ bannerState: bannerState })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { shouldRender: shouldRender, onDismiss: onDismiss } = (0, $86NSs.useRegisterNav4PromptBanner)(bannerState);
    const handleOnDismiss = ()=>{
        onDismiss();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'banner',
                actionSubjectId: 'nav4PromptBanner',
                source: 'nav4PromptBanner',
                attributes: {
                    isReminderBanner: (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner')
                }
            }
        }).fire();
    };
    return shouldRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ebWzV.Nav4PromptBannerComponent), {
        onDismiss: handleOnDismiss
    }) : null;
};
const $f35d5c2a7033b5e6$export$18e39ddabf189c4 = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).DISCO
})(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $3PXtn.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($f35d5c2a7033b5e6$var$Nav4PromptBannerContainerComponent, {
            bannerState: bannerState
        })));

const $f35d5c2a7033b5e6$export$268b68c89890fd2b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bU-5j",
    loader: async ()=>(await Promise.resolve(module.exports)).Nav4PromptBanner,
    name: 'Nav4PromptBanner'
});

});
parcelRegister("ebWzV", function(module, exports) {

$parcel$export(module.exports, "Nav4PromptBannerComponent", () => $41ad12fad553feeb$export$ec0ecfcf6b56616e);
/* Nav4PromptBannerComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $iXCQx = parcelRequire("iXCQx");

var $1qfLF = parcelRequire("1qfLF");

var $lnqHu = parcelRequire("lnqHu");

var $fpGTa = parcelRequire("fpGTa");

var $inPa6 = parcelRequire("inPa6");

var $1Whri = parcelRequire("1Whri");

var $9wGTI = parcelRequire("9wGTI");

var $1NBp8 = parcelRequire("1NBp8");

var $gz8ZY = parcelRequire("gz8ZY");
const $41ad12fad553feeb$var$NAVIGATION_RESOURCE_URL = 'https://support.atlassian.com/navigation/resources/';
const $41ad12fad553feeb$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    bannerContentWithLink: {
        id: "side-navigation.global-banner.content-with-link",
        defaultMessage: "The <a>new navigation</a> is now available and will be automatically turned on in the coming weeks. Turn it on for your team now or start with just yourself."
    },
    bannerReminderContentWithLink: {
        id: "side-navigation.global-banner-reminder.content-with-link",
        defaultMessage: "The <a>new navigation</a> will be automatically turned on the week of May 19. If you haven\u2019t yet, turn it on for yourself or your team now."
    },
    bannerCTA: {
        id: "side-navigation.global-banner.cta",
        defaultMessage: "Go to settings"
    },
    bannerCloseLabel: {
        id: "side-navigation.global-banner.close.label",
        defaultMessage: "Close"
    }
});
const $41ad12fad553feeb$var$styles = {
    banner: "_1yt41b66 _1bsb1osq _bfhkcdhy",
    bannerHeightNav3: "_4t3i8vuz",
    bannerHeight: "_4t3ickbl",
    bannerContent: "_19bvutpp _u5f3u2gc"
};
const $41ad12fad553feeb$export$ec0ecfcf6b56616e = ({ onDismiss: onDismiss })=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'displayed',
                actionSubject: 'banner',
                actionSubjectId: 'nav4PromptBanner',
                attributes: {
                    isReminderBanner: (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner')
                },
                source: 'nav4PromptBanner'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleLinkClick = (e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'nav4PromptBanner',
                source: 'nav4PromptBanner',
                attributes: {
                    isReminderBanner: (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner')
                }
            }
        }).fire();
        window.open((0, $1NBp8.ADMIN_NEW_FEATURES).toUrl(), '_blank');
    };
    const handleResourceLinkClick = (e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'nav4PromptBanner',
                source: 'nav4PromptBanner',
                attributes: {
                    isReminderBanner: (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner')
                }
            }
        }).fire();
        window.open($41ad12fad553feeb$var$NAVIGATION_RESOURCE_URL);
    };
    return /*#__PURE__*/ $gwFzn.createElement((0, $1s5hv.default), {
        justifyContent: "space-between",
        xcss: (0, $1Whri.cx)($41ad12fad553feeb$var$styles.bannerContent, $41ad12fad553feeb$var$styles.banner, isNav4Enabled ? $41ad12fad553feeb$var$styles.bannerHeight : $41ad12fad553feeb$var$styles.bannerHeightNav3),
        as: "div",
        alignItems: "center"
    }, /*#__PURE__*/ $gwFzn.createElement((0, $u9agA.default), null, /*#__PURE__*/ $gwFzn.createElement((0, $iXCQx.default), {
        color: "color.text.inverse"
    }, (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner') ? /*#__PURE__*/ $gwFzn.createElement((0, $4jR19.default), {
        ...$41ad12fad553feeb$export$a7357cdd1f0b0168.bannerReminderContentWithLink,
        values: {
            a: (chunks)=>/*#__PURE__*/ $gwFzn.createElement((0, $fpGTa.default), {
                    href: $41ad12fad553feeb$var$NAVIGATION_RESOURCE_URL,
                    onClick: handleResourceLinkClick,
                    style: {
                        color: "var(--ds-text-inverse, #FFFFFF)"
                    }
                }, chunks)
        }
    }) : /*#__PURE__*/ $gwFzn.createElement((0, $4jR19.default), {
        ...$41ad12fad553feeb$export$a7357cdd1f0b0168.bannerContentWithLink,
        values: {
            a: (chunks)=>/*#__PURE__*/ $gwFzn.createElement((0, $fpGTa.default), {
                    href: $41ad12fad553feeb$var$NAVIGATION_RESOURCE_URL,
                    onClick: handleResourceLinkClick,
                    style: {
                        color: "var(--ds-text-inverse, #FFFFFF)"
                    }
                }, chunks)
        }
    })), "\xa0", /*#__PURE__*/ $gwFzn.createElement((0, $fpGTa.default), {
        href: (0, $1NBp8.ADMIN_NEW_FEATURES).toUrl(),
        onClick: handleLinkClick,
        style: {
            color: "var(--ds-text-inverse, #FFFFFF)"
        }
    }, /*#__PURE__*/ $gwFzn.createElement((0, $4jR19.default), $41ad12fad553feeb$export$a7357cdd1f0b0168.bannerCTA))), /*#__PURE__*/ $gwFzn.createElement((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ $gwFzn.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)",
                spacing: "none"
            }),
        label: /*#__PURE__*/ $gwFzn.createElement((0, $4jR19.default), $41ad12fad553feeb$export$a7357cdd1f0b0168.bannerCloseLabel),
        appearance: "subtle",
        onClick: onDismiss
    }));
};

});

parcelRegister("86NSs", function(module, exports) {

$parcel$export(module.exports, "useRegisterNav4PromptBanner", () => $69e191b4ee73f701$export$4039b1edc01c786);

var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $a1A9A = parcelRequire("a1A9A");


var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $9wGTI = parcelRequire("9wGTI");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $dKIZZ = parcelRequire("dKIZZ");
const $69e191b4ee73f701$export$41956b146268af93 = 'Nav4PromptBanner';
const $69e191b4ee73f701$export$8489406a106361d1 = 172800000;
// same value used for navHeight in BannerStateContainer in @confluence/banners
const $69e191b4ee73f701$var$BANNER_HEIGHT = 56;
const $69e191b4ee73f701$export$4039b1edc01c786 = (bannerState = null)=>{
    const { nav4AdminOptedIn: isNav4SiteWideEnabled } = (0, $dKIZZ.useGetNav4OptIn)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { data: data, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $a1A9A.OperationsQuery), {
        skip: !userId
    });
    if (error && (0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const isAdmin = data?.siteOperations?.application?.includes('administer');
    // The reminder banner should be displayed before users are a few days away from being forced into nav 4.
    // The only distinction between the two banners is the text.
    const storageKey = (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner') ? (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NAV4_PROMPT_REMINDER_BANNER_FIRST_DISMISSED : (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_NAV4_PROMPT_BANNER_FIRST_DISMISSED;
    const getIsDismissed = ()=>{
        const dismissedValue = (0, $e9zUf.confluenceLocalStorageInstance).getItem(storageKey);
        if (!(0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner')) return dismissedValue === 'true';
        const dismissedDateTime = new Date(dismissedValue).getTime();
        // Validate storage key value as a date, since we previously stored this value as a true/false string
        if (!isNaN(dismissedDateTime)) {
            // If the banner was dismissed more than 48 hours ago, we want to re-show it
            if (Date.now() - dismissedDateTime > $69e191b4ee73f701$export$8489406a106361d1) {
                (0, $e9zUf.confluenceLocalStorageInstance).setItem(storageKey, null);
                return false;
            }
            return true;
        } else if (dismissedValue === 'true') {
            // If the banner was previously dismissed as 'true', we want to ensure we maintain the dismissed state and update the local storage value to the current date
            (0, $e9zUf.confluenceLocalStorageInstance).setItem(storageKey, new Date().toString());
            return true;
        } else {
            // If the banner was previously not dismissed, we want to ensure we maintain the dismissed state and reset the local storage value
            (0, $e9zUf.confluenceLocalStorageInstance).setItem(storageKey, null);
            return false;
        }
    };
    const [isDismissed, setIsDismissed] = (0, $gwFzn.useState)(getIsDismissed());
    const onDismiss = (0, $gwFzn.useCallback)(()=>{
        const dismissedValue = (0, $9wGTI.fg)('confluence_nav4_admin_reminder_banner') ? new Date().toString() : 'true';
        (0, $e9zUf.confluenceLocalStorageInstance).setItem(storageKey, dismissedValue);
        setIsDismissed(true);
        bannerState?.hide($69e191b4ee73f701$export$41956b146268af93);
    }, [
        bannerState,
        storageKey
    ]);
    /**
	 * Conditions to show Nav4PromptBanner
	 * - If non-reminder banner, do not show if banner has been previously dismissed
	 * - If reminder banner, do not show if banner has been dismissed in the last 48 hours
	 * - Nav4 GA rollout phase 1
	 * - Nav4 GA phase 2 has not started
	 * - Site admins
	 * - Site wide opt-in is false
	 */ const shouldRender = !isNav4SiteWideEnabled && !isDismissed && isAdmin && (0, $9wGTI.fg)('confluence_nav4_ga_phase_1') && !(0, $9wGTI.fg)('confluence_nav4_ga_phase_2');
    if (shouldRender) bannerState?.show($69e191b4ee73f701$export$41956b146268af93, $69e191b4ee73f701$var$BANNER_HEIGHT);
    return {
        shouldRender: Boolean(shouldRender),
        onDismiss: onDismiss
    };
};

});



parcelRegister("lqy4C", function(module, exports) {

$parcel$export(module.exports, "useHardStorageEnforcement", () => $047fd93b8f400f5d$export$5419ac0b96bac54b);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $4c1VG = parcelRequire("4c1VG");

var $alLTz = parcelRequire("alLTz");

var $cLhhP = parcelRequire("cLhhP");
const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $gwFzn.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};

});
parcelRegister("4c1VG", function(module, exports) {

$parcel$export(module.exports, "useGetCurrentStorageUsage", () => $1f652a8c0a42982a$export$8bf54c39c48ff2d2);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $xQxzY = parcelRequire("xQxzY");
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query useGetCurrentStorageUsageGetCurrentStorageUsageQuery{storage{bytesUsed isStorageEnforcementGracePeriodComplete gracePeriodEndDate}}`, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};

});

parcelRegister("cLhhP", function(module, exports) {

$parcel$export(module.exports, "useBlockCreateModalStore", () => $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc);
$parcel$export(module.exports, "useBlockCreateModalActions", () => $ff89d2fd8e30c2ae$export$d0e21e34c085fe56);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");
const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $4ZoIm.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $iFWZA.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $iFWZA.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);

});



//# sourceMappingURL=BannerContainer.17f2df29.js.map
